import { render, staticRenderFns } from "./index2_h5.vue?vue&type=template&id=020ab665&scoped=true&"
import script from "./index2_h5.vue?vue&type=script&lang=js&"
export * from "./index2_h5.vue?vue&type=script&lang=js&"
import style0 from "./index2_h5.vue?vue&type=style&index=0&id=020ab665&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ab665",
  null
  
)

export default component.exports